import { render, staticRenderFns } from "./purchaseAnalysis.vue?vue&type=template&id=d7a4363c&"
import script from "./purchaseAnalysis.vue?vue&type=script&lang=ts&"
export * from "./purchaseAnalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports